import { handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import React from 'react';
import { TotalRecipients } from '../../components/AlertWizard/Components/TotalRecipients';
import { type } from './types';
const WidgetTotalRecipients = (props) => {
    var _a;
    const { internalData, update, render } = props;
    const handleCalculateRecipients = React.useCallback((validRecipientsFound) => {
        if (!!internalData.validRecipientsFound !== validRecipientsFound) {
            internalData.validRecipientsFound = validRecipientsFound;
            update();
            render();
        }
    }, [internalData, update, render]);
    const formData = props.rootData;
    // Must create a new object here because common-form-ui mutates formData.
    // Standard React components do not render properly when props are mutated.
    const recipients = Object.assign({}, formData.recipients);
    return (React.createElement(TotalRecipients, { recipients: recipients, channels: formData === null || formData === void 0 ? void 0 : formData.channels, emailCc: formData === null || formData === void 0 ? void 0 : formData.emailCc, disabled: props.config.disabled, requireRecipients: !!((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.requireRecipients), onCalculateRecipients: handleCalculateRecipients })
    // Note than TotalRecipients component displays the error, no need to display error in this widget.
    );
};
export const widgetTotalRecipients = {
    type,
    validate: (props) => {
        var _a;
        if ((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.requireRecipients) {
            return props.internalData.validRecipientsFound ? undefined : props.config.validate.requireRecipientsMessage;
        }
        return undefined;
    },
    update: (props) => {
        // Need to rerender this widget every time form changes to pick up changes to recipients.
        props.update();
        return handleWidgetUpdate(props);
    },
    component: WidgetTotalRecipients,
};
